import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FormTemplateGridService } from "./../services/form-template-grid.service";
import { ZpDataService } from "./../services/zp-data.service";
import { IDataGrid } from "./../models/data-grid.model";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "./../models/user.model";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { Location } from "@angular/common";
import { NotificationService } from "../services/notification.service";
import { ZPNotification } from "../models/zpnotification";
import { ThemeService } from "../theme/theme-service.service";
import { DynamicSuggestedDelegatesService } from "../services/dynamic-suggested-delegates.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";

@Component({
  selector: "app-dynamic-grid",
  templateUrl: "./dynamic-grid.component.html",
  styleUrls: ["./dynamic-grid.component.scss"],
  standalone: false,
})
export class DynamicGridComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  public mySubscription: any;
  public templateName: string;
  public newItem: any;
  public Id: any;
  public action: any;
  public editItem;
  public myFormTemplate: IDataGrid;
  public myTemplateParam;
  public itemList;
  public myItemList;
  public myItemList2;
  public itemName;
  public reviewStatus;
  public deleteId;
  public showDialog = false;
  public localData;
  public sectionTitle: string;
  public visible = false;
  public myResult;
  public itemToDeleteId;
  public itemNameforDialog;
  public noItems = false;
  public myUser: IUser;
  public viewOnly = false;
  public canEdit = true;
  public markedComplete = false;
  public showAddButton = true;
  public showDeleteButton = true;
  public delegatesList = false;
  public delegatesById: {}[] = [];
  public changedByList: {}[] = [];
  public collapsed = [];
  public noItemDeleted = false;
  public dataIsLoaded: boolean = false;
  public hasPlan;
  public showOvaleDiv: boolean;
  public registered: boolean = false;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public delegateRelation = "Spouse";
  public statusExplanations;
  public refCode: any;
  public companyName: any;
  public companyEmail: any;
  public subscription2: Promise<void>;
  public user: any;
  public professionalIsDelegate: boolean;
  public companyDetails: {
    userType?: string;
    professionalLicense?: string;
    funded?: boolean;
    hideSponsor?: boolean;
    directInvoice?: boolean;
    email?: string;
    company?: string;
    logo?: string;
    firstName?: string;
    lastName?: string;
    profession?: string;
  };
  public allDelegateRelations: string[] = [
    "Spouse",
    "Child",
    "Sibling",
    "Parent",
    "Accountant",
    "Solicitor",
    "Wealth Manager",
    "Professional Advisor",
    "Friend",
    "Partner",
  ];
  public availableDelegatesRelations: string[] = [];
  public removedDelegates: Set<string> = new Set();
  public shortListSize: number = 3;
  public showMore: boolean = true;
  public showLess: boolean = false;
  openedIndex: number | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formTemplateGridService: FormTemplateGridService,
    private zenplansDataService: ZpDataService,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private notificationService: NotificationService,
    public themeService: ThemeService,
    private dynamicSuggestedDelegates: DynamicSuggestedDelegatesService,
    private getInfoAndPass: GetInfoAndPassService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.templateName = params.get("templateName");
      this.action = params.get("action");
    });
    this.subscription = this.userInfo
      .getMessage()
      .subscribe(async (user: any) => {
        this.myUser = JSON.parse(user);
      });
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.dataIsLoaded = false;
    await this.fillFormTemplateInfo(this.templateName);
    this.sectionTitle = this.myFormTemplate.sectionTitle;
    if (this.sectionTitle.toLowerCase().includes("general expenses")) {
      this.showAddButton = false;
      this.showDeleteButton = false;
    }
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
    console.log("myUser: ", this.myUser);
    this.refCode = this.myUser.refCode;
    console.log("refCode: ", this.refCode);
    await this.zenplansDataService.setRefCode(this.refCode);
    this.companyDetails = await this.zenplansDataService.getRefCodeInfo();
    console.log("companyDetails: ", this.companyDetails);
    if (this.companyDetails) {
      this.companyEmail = await this.companyDetails.email;
      this.companyName = await this.companyDetails.company;
    }

    this.subscription = this.zenplansDataService.currentMessage.subscribe(
      async (message) => {
        this.zenplansDataService
          .getSection(this.myFormTemplate.sectionTitle)
          .then(async (section) => {
            if (section && section.length > 0) {
              this.itemList = section;
              this.myItemList = this.itemList;
              console.log("myItemList: ", this.myItemList);
              let i = 0;
              this.myItemList.map((item) => {
                if (item.digitalLifePermission === undefined) {
                  item.digitalLifePermission = "future";
                }
                this.collapsed[i++] = false;
              });
              this.initializeShortList();
              this.myItemList2 = this.itemList;
              let now = new Date();
              let listLength = this.myItemList.length;
              let changedByName = "";
              let loggeInUserName =
                this.myUser.firstName + " " + this.myUser.lastName;
              let changedBy = {};
              for (var counter = 0; counter < listLength; counter++) {
                changedByName = "";
                if (this.myItemList[counter].lastUpdateBy == this.myUser.Id) {
                  changedByName = loggeInUserName;
                } else {
                  changedBy = this.changedByList.find(
                    (changer) =>
                      changer["Id"] == this.myItemList[counter].lastUpdateBy,
                  );
                  //building a list of user names to minimize round trips
                  if (!changedBy) {
                    changedByName = await this.zenplansDataService.getUserName(
                      this.myItemList[counter].lastUpdateBy,
                    );
                    this.changedByList.push({
                      Id: this.myItemList[counter].lastUpdateBy,
                      name: changedByName,
                    });
                  } else {
                    changedByName = changedBy["name"];
                  }
                }
                this.myItemList[counter].lastUpdateByName = changedByName; //await this.zenplansDataService.getUserName(kk.lastUpdateBy);
                if (!this.myItemList[counter].lastUpdateByName) {
                  this.myItemList[counter].lastUpdateByName = "Unknown";
                }
                if (
                  !this.myItemList[counter].itemName &&
                  this.myItemList[counter].firstName &&
                  this.myItemList[counter].lastName
                ) {
                  //for delegates for example where therre is no itemname
                  //We will also need a grid for users for the professionals
                  //and for zenplans admin
                  this.myItemList[counter].itemName =
                    this.myItemList[counter].firstName +
                    " " +
                    this.myItemList[counter].lastName;
                }
              }
              this.noItems = false;
              this.dataIsLoaded = true;
            } else {
              this.dataIsLoaded = true;
              this.noItems = true;
            }
            this.delegatesList = true;
            //check which delegates are registered
            //in order to toggle the remind button
            let indexcounter = 0;
          });
        if (!this.myItemList) {
          this.initializeShortList();
        }
      },
    );
  }

  private checkIfProfessionalIsDelegate(companyEmail: any): any {
    // Check if there is an email in myItemList that is the same as the delegate's email
    if (this.myItemList && this.myItemList.length) {
      for (let i = 0; i < this.myItemList.length; i++) {
        const myDelegate = this.myItemList[i];
        if (myDelegate.email === companyEmail) {
          this.professionalIsDelegate = true;
          break;
        } else {
          this.professionalIsDelegate = false;
        }
      }
    } else {
      this.professionalIsDelegate = false;
    }
  }

  private initializeShortList() {
    this.checkIfProfessionalIsDelegate(this.companyEmail);
    const removedCategories =
      JSON.parse(localStorage.getItem("removedCategories")) || [];

    // Exclude the professional's relation
    const filteredDelegates = this.allDelegateRelations.filter(
      (delegate) =>
        !this.removedDelegates.has(delegate) &&
        !removedCategories.includes(delegate) &&
        (!this.companyDetails || delegate !== this.companyDetails.profession),
    );

    // If myItemList is empty, display a default set of suggestions
    if (!this.myItemList || this.myItemList.length === 0) {
      this.availableDelegatesRelations = filteredDelegates.slice(
        0,
        this.shortListSize,
      );
    } else {
      // Exclude the relations already present in myItemList from the list
      const takenRelationships = new Set(
        this.myItemList.map((item) => item.delegateRelation),
      );

      this.availableDelegatesRelations = filteredDelegates
        .filter((delegate) => !takenRelationships.has(delegate))
        .slice(0, this.shortListSize);
    }
  }

  toggleActions(index: number): void {
    this.openedIndex = this.openedIndex === index ? null : index;
  }

  showAllDelegatesRelations() {
    const removedCategories =
      JSON.parse(localStorage.getItem("removedCategories")) || [];

    // Update the list of available suggestions by filtering out removed and existing ones
    const filteredDelegates = this.allDelegateRelations.filter(
      (delegate) =>
        !this.removedDelegates.has(delegate) &&
        !removedCategories.includes(delegate) &&
        (!this.companyDetails || delegate !== this.companyDetails.profession),
    );

    // If myItemList is empty, display a default set of suggestions
    if (!this.myItemList || this.myItemList.length === 0) {
      this.availableDelegatesRelations = filteredDelegates;
    } else {
      // Exclude the relations already present in myItemList from the list
      const takenRelationships = new Set(
        this.myItemList.map((item) => item.delegateRelation),
      );

      this.availableDelegatesRelations = filteredDelegates.filter(
        (delegate) => !takenRelationships.has(delegate),
      );
    }

    this.showMore = false;
    this.showLess = true;
  }

  showShortListOfDelegatesRelations() {
    const removedCategories =
      JSON.parse(localStorage.getItem("removedCategories")) || [];

    // Update the list of available suggestions by filtering out removed and existing ones
    const filteredDelegates = this.allDelegateRelations.filter(
      (delegate) =>
        !this.removedDelegates.has(delegate) &&
        !removedCategories.includes(delegate) &&
        (!this.companyDetails || delegate !== this.companyDetails.profession),
    );

    // If myItemList is empty, display a default set of suggestions
    if (!this.myItemList || this.myItemList.length === 0) {
      this.availableDelegatesRelations = filteredDelegates.slice(
        0,
        this.shortListSize,
      );
    } else {
      // Exclude the relations already present in myItemList from the list
      const takenRelationships = new Set(
        this.myItemList.map((item) => item.delegateRelation),
      );

      this.availableDelegatesRelations = filteredDelegates
        .filter((delegate) => !takenRelationships.has(delegate))
        .slice(0, this.shortListSize);
    }

    this.showLess = false;
    this.showMore = true;
  }

  // ...

  removeDelegateRelation(index: number) {
    const removedDelegate = this.availableDelegatesRelations[index];

    // Store the removed category in the queue in local storage
    this.pushToQueue(removedDelegate);

    // Update the local state
    this.removedDelegates.add(removedDelegate);
    this.availableDelegatesRelations.splice(index, 1);

    // Check if all suggestions in the short list are removed, then show all suggestions
    if (this.availableDelegatesRelations.length === 0) {
      this.showAllDelegatesRelations();
    }

    // Remove the category from the queue in local storage after 6 months
    setTimeout(() => {
      this.popFromQueue();

      // Update the local state or perform any other actions as needed

      // Trigger change detection if needed (depends on your application structure)
      this.zone.run(() => {
        // Code inside this function will trigger change detection
      });
    }, 15000000000); // 6 months in milliseconds
  }

  private pushToQueue(item: any) {
    const queue = JSON.parse(localStorage.getItem("removedCategories")) || [];
    queue.push(item);
    localStorage.setItem("removedCategories", JSON.stringify(queue));
  }

  private popFromQueue() {
    const queue = JSON.parse(localStorage.getItem("removedCategories")) || [];
    const item = queue.shift(); // Remove and return the first item in the queue
    localStorage.setItem("removedCategories", JSON.stringify(queue));
    return item;
  }

  async addProfessionalAsDelegate(companyDetails) {
    console.log("companyDetails: ", companyDetails);
    let profession = companyDetails.profession;
    let professionalId = companyDetails.professionalId;
    let refCodeDetails = companyDetails;
    this.myUser.professionalId = professionalId;
    await this.zenplansDataService.updateUser(this.myUser, "no-notif");
    console.log("myUser: ", this.myUser);
    this.getInfoAndPass.getInfoAndPass({
      professionalProfession: profession,
      professionalId: professionalId,
    });
    this.zenplansDataService.inviteProfessionalAsDelegate(
      this.refCode,
      profession,
      "no-notif",
      refCodeDetails,
    );
    this.refresh();
    // this.ngOnInit();
  }

  async refresh() {
    await this.zenplansDataService.revalidateCache();
    this.zenplansDataService.changeMessage(
      JSON.stringify({ "cache revalidated": true }),
    );
  }

  async fillFormTemplateInfo(templateName: string) {
    await this.formTemplateGridService
      .getFormTemplateAsync(templateName)
      .then(async (kk) => {
        this.myFormTemplate = kk;
        let mySectionTitle = kk.sectionTitle;
        return mySectionTitle;
      });
  }

  add() {
    this.router.navigate(["/" + this.myFormTemplate.addUrl]);
  }

  handleDelegateAdded() {
    this.router.navigate(["/dynamicformdataentry/delegate_1"]);
  }

  view(id: string) {
    this.router.navigate(["/" + this.myFormTemplate.viewUrl + "/" + id]);
  }

  edit(id: string) {
    this.router.navigate(["/" + this.myFormTemplate.editUrl + "/" + id]);
  }

  async deleteByEvent(choice) {
    this.showDialog = !this.showDialog;
    if (choice === "Yes") {
      this.notificationService.changeMessage(
        new ZPNotification(
          "Delegate deleted.",
          undefined,
          undefined,
          "Your delegate was permanently deleted. You will need to add them again if you would like to restore them to your plan.",
        ),
      );
      let clientId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      var itemAboutToBeDeleted = await this.zenplansDataService.getItem(
        this.itemToDeleteId,
        this.sectionTitle,
        clientId,
      );
      await this.zenplansDataService.deleteDelegate(
        this.itemToDeleteId,
        this.myFormTemplate.sectionTitle,
        clientId,
      );
      var Id: string;
      if (this.myUser.sharedPlanUserId) {
        Id = this.myUser.sharedPlanUserId;
      } else {
        Id = this.myUser.Id;
      }
      this.refresh();
      this.zenplansDataService.addLog(
        this.sectionTitle,
        this.itemToDeleteId,
        Id,
        "",
        JSON.stringify(itemAboutToBeDeleted),
        "",
        "delete",
      );
    }
  }

  async callDialog(id, name) {
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // private getTakenRelationships(): Set<string> {
  //   console.log("function is called.");
  //   return new Set(
  //     (this.myItemList ?? []).length > 0
  //       ? this.myItemList.map((delegate) => delegate.delegateRelation)
  //       : this.allDelegateRelations
  //   );
  // }

  // private updateShortList() {
  //   const takenRelationships = this.getTakenRelationships();

  //   // Exclude the professional's relation and relations already in myItemList
  //   const filteredDelegates = this.allDelegateRelations.filter(
  //     (delegate) =>
  //       !takenRelationships.has(delegate) &&
  //       !this.removedDelegates.has(delegate) &&
  //       !this.myItemList.some((item) => item.relation === delegate)
  //   );

  //   // Exclude the professional's relation from the list
  //   this.availableDelegatesRelations = filteredDelegates.filter(
  //     (delegate) => delegate !== this.companyDetails.profession
  //   );
  // }
}
